import React from "react";
import OptOutForm from "../../components/OptOutForm";

export default function DoNotSell() {
  return (
    <OptOutForm
      variant="sale-share"
      testid="legal-do-not-sell"
      eyebrow="BlueRoam Ltd · CCPA/CPRA + VCDPA + CPA + CTDPA + UCPA + TDPSA + OCPA"
      title="Do Not Sell or Share My Personal Information"
      intro="If you are a US resident, you can ask BlueRoam to stop “selling” or “sharing” your personal information for cross-context behavioural advertising. We honour the request within 15 days and forever, until you re-opt-in."
      successLine="We will not “sell” or “share” your personal information for cross-context behavioural advertising. The setting is stored in your browser and is also passed to our analytics partners on every subsequent visit."
    />
  );
}
